module.exports = __webpack_public_path__ + "img/unicampoLogo.7aee5771.jpg";